import { createReducer } from "reduxsauce";

import ReducerRegister from "../../ReducerRegister";
import SpokenBooksService from "../../../services/screens/chinesepark/SpokenBooksService";
import { ActionTypes } from "../../actionTypes/components/chinesepark/SpokenBooksActionTypes";
import AsyncActionReducers from "../../AsyncActionReducers";
import UIDs from "../../../UIDs";

const uid = UIDs.components.chinesepark.spokenBooksModal;

//
// Actions
//
const Actions = {
    loadScreenViewAsync: (vo, units, selectedUnits) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SCREEN_VIEW_ASYNC });

            SpokenBooksService.loadScreenView(
                vo,
                response => {
                    dispatch(Actions.loadScreenViewSuccess(response, units, selectedUnits));
                },
                error => {
                    dispatch(Actions.loadScreenViewFailure(error));
                }
            );
        };
    },

    loadScreenViewSuccess: (data, units, selectedUnits) => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_SUCCESS,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        postReducer: loadScreenViewSuccessPostReducer,
        data,
        units,
        selectedUnits,
    }),

    loadScreenViewFailure: error => ({
        type: ActionTypes.LOAD_SCREEN_VIEW_FAILURE,
        parentType: ActionTypes.LOAD_SCREEN_VIEW_ASYNC,
        error
    }),

    loadSectionsAsync: (partnerId, courseId) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_SECTIONS_ASYNC });

            SpokenBooksService.loadSections(
                { partnerId, courseId },
                response => {
                    dispatch(Actions.loadSectionsSuccess(response, courseId));
                },
                error => {
                    dispatch(Actions.loadSectionsFailure(error));
                }
            );
        };
    },

    loadSectionsSuccess: (data, courseId) => ({
        type: ActionTypes.LOAD_SECTIONS_SUCCESS,
        parentType: ActionTypes.LOAD_SECTIONS_ASYNC,
        postReducer: loadSectionsSuccessPostReducer,
        data,
        courseId,
    }),

    loadSectionsFailure: error => ({
        type: ActionTypes.LOAD_SECTIONS_FAILURE,
        parentType: ActionTypes.LOAD_SECTIONS_ASYNC,
        error
    }),

    loadUnitsAsync: (partnerId, sectionId) => {
        return (dispatch /*, getState*/) => {
            dispatch({ type: ActionTypes.LOAD_UNITS_ASYNC });

            SpokenBooksService.loadUnits(
                { partnerId, id: sectionId },
                response => {
                    dispatch(Actions.loadUnitsSuccess(response, sectionId));
                },
                error => {
                    dispatch(Actions.loadUnitsFailure(error));
                }
            );
        };
    },

    loadUnitsSuccess: (data, sectionId) => ({
        type: ActionTypes.LOAD_UNITS_SUCCESS,
        parentType: ActionTypes.LOAD_UNITS_ASYNC,
        postReducer: loadUnitsSuccessPostReducer,
        data,
        sectionId,
    }),

    loadUnitsFailure: error => ({
        type: ActionTypes.LOAD_UNITS_FAILURE,
        parentType: ActionTypes.LOAD_UNITS_ASYNC,
        error
    }),

    selectCourseType: id => ({
        type: ActionTypes.SELECT_COURSE_TYPE,
        id
    }),

    selectCourse: id => ({
        type: ActionTypes.SELECT_COURSE,
        id
    }),

    selectSection: id => ({
        type: ActionTypes.SELECT_SECTION,
        id
    }),

    selectUnit: (id, checked) => ({
        type: ActionTypes.SELECT_UNIT,
        id,
        checked
    }),
};

//
// Initial State
//
const INITIAL_STATE = {
    courseTypes: null,
    courses: null,
    sections: null,
    units: null,
    courseUnits: null,
    selectedCourseType: 1,
    selectedSectionType: null,
    selectedCourse: null,
    selectedSection: null,
    selectedUnits: new Set(),
    selectedLastUnits: [],
    reviseUnits: new Map(),
};

//
// Reducers
//
const loadScreenViewSuccessPostReducer = (state, { data, units, selectedUnits }) => {
    const { courseTypes, courses } = data;

    return { ...state, courseTypes, courses, units, selectedUnits: new Set(selectedUnits), selectedLastUnits: [] };
};

const loadSectionsSuccessPostReducer = (state, { data, courseId }) => {
    let sections = Array.from(state.sections || []);
    Array.from(data.sections).forEach(s => {
        sections.push({ ...s, courseId });
    })

    return { ...state, sections };
};

const loadUnitsSuccessPostReducer = (state, { data, sectionId }) => {
    let units = Array.from(state.units || []);
    Array.from(data.units).forEach(u => {
        units.push({ ...u, sectionId });
    })

    return { ...state, units, selectedSection: sectionId };
};

const selectCourseTypeReducer = (state, { id }) => {
    return { ...state, selectedCourseType: id, /* selectedSectionType: null,  */selectedCourse: null, selectedSection: null };
}

const selectCourseReducer = (state, { id }) => {
    const course = state.courses.find(c => c.id === id);
    return { ...state, selectedCourse: id, selectedSection: null, selectedSectionType: course.sectionType };
}

const selectSectionReducer = (state, { id }) => {
    return { ...state, selectedSection: id };
}

const selectUnitReducer = (state, { id, checked }) => {
    let selectedUnits = new Set(state.selectedUnits);
    let selectedLastUnits = [];
    const units = Array.from(state.units || []).filter(u => u.sectionId === state.selectedSection);

    if (!id) {
        if (checked) {
            units.forEach(u => {
                const unitId = u.unitType === "POKA1" ? `${u.id}-100-0` : u.id;
                selectedUnits.add(unitId);
            })
        } else {
            units.forEach(u => {
                const unitId = u.unitType === "POKA1" ? `${u.id}-100-0` : u.id;
                selectedUnits.delete(unitId);
            })
        }
    } else if (Array.isArray(id)) {
        id.forEach(v => {
            selectedUnits.add(v);
            selectedLastUnits.push(v);
        });
    }
    else {
        if (selectedUnits.has(id)) {
            selectedUnits.delete(id);
        } else {
            selectedUnits.clear();
            selectedUnits.add(id);
        }
    }

    if (selectedLastUnits.length === 0) {
        selectedLastUnits = state.selectedLastUnits
    }

    return { ...state, selectedUnits, selectedLastUnits };
};


// Use reduxsauce's createReducer to make it clearer for
// each action handler
const mergedReducer = createReducer(INITIAL_STATE, {
    [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SCREEN_VIEW_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.LOAD_SECTIONS_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_SECTIONS_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_SECTIONS_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.LOAD_UNITS_ASYNC]: AsyncActionReducers.actionReducer,
    [ActionTypes.LOAD_UNITS_SUCCESS]: AsyncActionReducers.successReducer,
    [ActionTypes.LOAD_UNITS_FAILURE]: AsyncActionReducers.failureReducer,
    [ActionTypes.SELECT_COURSE_TYPE]: selectCourseTypeReducer,
    [ActionTypes.SELECT_COURSE]: selectCourseReducer,
    [ActionTypes.SELECT_SECTION]: selectSectionReducer,
    [ActionTypes.SELECT_UNIT]: selectUnitReducer,
});

// Enable dynamically register and unregister reducer
const reducer = new ReducerRegister(uid, mergedReducer);

export { ActionTypes, Actions, reducer, INITIAL_STATE };
